import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MuiButton from '@material-ui/core/Button'
import '../../utils/styles/scss/Header.scss'

import AuthenticatedAppBar from './AuthenticatedAppBar'

export default function Header() {
  const user = useSelector((state) => state.user)
  const [anchorEl, setAnchorEl] = useState(null)

  const openNavMenu = (e) => setAnchorEl(e.currentTarget)
  const closeNavMenu = () => setAnchorEl(null)

  if (user) {
    return (
      <div style={{ marginLeft: '-1%', marginRight: '-1%' }}>
        <AuthenticatedAppBar />
      </div>
    )
  }

  return (
    <div style={{ marginLeft: '-1%', marginRight: '-1%' }}>
      <div className="d-flex justify-content-between align-items-center py-lg-4 py-2">
        <Grid
          container
          alignItems="center"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >

          {!user && (
            <Grid
              container
              alignItems="center"
              wrap="nowrap"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '10px',
              }}
            >
              <Grid item>
                <Link to="/">
                  <img
                    id="logo"
                    src="/media/logo.png"
                    height={75}
                    width="auto"
                    alt="WeeStoryWorld logo"
                    title="WeeStoryWorld"
                    style={{ cursor: 'pointer' }}
                  />
                </Link>
              </Grid>
              <Grid
                item
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'nowrap',
                }}
              >
                {/* smDown = show on md+ only; smUp = show below md — avoids gap where neither showed (md-only viewports) */}
                <Hidden smDown>
                  <MuiButton component={Link} to="/about" variant="outlined" size="small" className="ml-1">
                    About
                  </MuiButton>
                  <MuiButton component={Link} to="/library" variant="outlined" size="small" className="ml-1">
                    Library
                  </MuiButton>
                  <MuiButton component={Link} to="/blog" variant="outlined" size="small" className="ml-1">
                    Blog
                  </MuiButton>
                  <MuiButton component={Link} to="/membership" variant="outlined" size="small" className="ml-1">
                    Pricing
                  </MuiButton>
                  <MuiButton component={Link} to="/login" variant="outlined" size="small" className="ml-1">
                    Login
                  </MuiButton>
                  <MuiButton
                    component={Link}
                    to="/register"
                    variant="contained"
                    size="small"
                    className="ml-1"
                    style={{ backgroundColor: '#9CD350', color: '#1a1a1a' }}
                  >
                    Get started
                  </MuiButton>
                </Hidden>

                <Hidden smUp>
                  <IconButton
                    edge="end"
                    aria-label="open navigation menu"
                    onClick={openNavMenu}
                    style={{ marginRight: 4 }}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={closeNavMenu}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <MenuItem component={Link} to="/about" onClick={closeNavMenu}>
                      About
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/library"
                      onClick={closeNavMenu}
                    >
                      Library
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/blog"
                      onClick={closeNavMenu}
                    >
                      Blog
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/membership"
                      onClick={closeNavMenu}
                    >
                      Pricing
                    </MenuItem>
                    <MenuItem component={Link} to="/login" onClick={closeNavMenu}>
                      Login
                    </MenuItem>
                    <MenuItem
                      component={Link}
                      to="/register"
                      onClick={closeNavMenu}
                    >
                      Register
                    </MenuItem>
                  </Menu>
                </Hidden>
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  )
}
